"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _reactRedux = require("react-redux");

var _PropTypes = _interopRequireDefault(require("react-utils/PropTypes"));

var _react = _interopRequireWildcard(require("react"));

var _actions = require("settings-ui-sdk/Themes/actions");

var _selectors = require("settings-ui-sdk/Themes/selectors");

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _LoadingHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/LoadingHOC"));

var _ThemeTile = _interopRequireDefault(require("../components/ThemeTile"));

var ThemesSettingsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ThemesSettingsContainer, _PureComponent);

  function ThemesSettingsContainer() {
    (0, _classCallCheck2.default)(this, ThemesSettingsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ThemesSettingsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(ThemesSettingsContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.loadThemes();
    }
  }, {
    key: "renderThemeCard",
    value: function renderThemeCard(theme) {
      return _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 4
        },
        key: theme.id
      }, _react.default.createElement(_ThemeTile.default, {
        theme: theme
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fetchThemesRequestStatus = _this$props.fetchThemesRequestStatus,
          themes = _this$props.themes;
      return _react.default.createElement("div", null, _react.default.createElement(_UISubheader.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "website.themes.header"
        })
      }, _react.default.createElement("p", {
        className: "m-top-3"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "website.themes.intro"
      }))), _react.default.createElement("div", null, _react.default.createElement(_LoadingHOC.default, {
        requestStatuses: [fetchThemesRequestStatus]
      }, _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UIGrid.default, null, themes.toArray().map(this.renderThemeCard))))));
    }
  }]);
  return ThemesSettingsContainer;
}(_react.PureComponent);

ThemesSettingsContainer.propTypes = {
  themes: _PropTypes.default.instanceOf(_immutable.Map).isRequired,
  loadThemes: _PropTypes.default.func.isRequired,
  fetchThemesRequestStatus: _PropTypes.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    themes: (0, _selectors.getThemes)(state),
    fetchThemesRequestStatus: (0, _selectors.getFetchThemesRequestStatus)(state)
  };
};

var mapDispatchToProps = {
  loadThemes: _actions.loadThemes
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ThemesSettingsContainer);

exports.default = _default;
module.exports = exports.default;